<template>
  <div class="right-top">
    <div class="list">
      <div class="item day">
        <div class="name">
          <div class="icon"></div>
          日日走
        </div>
        <div class="per">{{ day_num ? day_width : 0 }}%</div>
        <div class="num">{{ day_num }}人</div>
      </div>
      <div class="item week">
        <div class="name">
          <div class="icon"></div>
          周周练
        </div>
        <div class="per">{{ week_num ? week_width : 0 }}%</div>
        <div class="num">{{ week_num }}人</div>
      </div>
      <div class="item month">
        <div class="name">
          <div class="icon"></div>
          月月访
        </div>
        <div class="per">{{ month_num ? month_width : 0 }}%</div>
        <div class="num">{{ month_num }}人</div>
      </div>
    </div>
    <div class="line">
      <div class="day" :style="`width:${day_width}%`"></div>
      <div class="week" :style="`width:${week_width}%`"></div>
      <div class="month" :style="`width:${month_width}%`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    day_num: 0,
    week_num: 0,
    month_num: 0,
  },
  computed: {
    day_width() {
      if (this.day_num * 1 || this.week_num * 1 || this.month_num * 1) {
        return Math.floor(((this.day_num * 1) / (this.day_num * 1 + this.week_num * 1 + this.month_num * 1)) * 10000)/100
      } else {
        return 33
      }
    },
    week_width() {
      if (this.day_num * 1 || this.week_num * 1 || this.month_num * 1) {
        return Math.floor(((this.week_num * 1) / (this.day_num * 1 + this.week_num * 1 + this.month_num * 1)) * 10000)/100
      } else {
        return 34
      }
    },
    month_width() {
      if (this.day_num * 1 || this.week_num * 1 || this.month_num * 1) {
        return Math.floor(((this.month_num * 1) / (this.day_num * 1 + this.week_num * 1 + this.month_num * 1)) * 10000)/100
      } else {
        return 33
      }
    },
  },
}
</script>

<style lang="less" scoped>
.right-top {
  padding: 20px 20px 0;
  .list {
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      font-size: 14px;
      color: #fff;
      + .item {
        margin-top: 14px;
      }
      .name {
        display: flex;
        .icon {
          width: 14px;
          height: 14px;
          background: #ff6c40;
          border-radius: 2px;
          margin-right: 15px;
        }
      }
      .num {
        color: #ff6c40;
      }
      &.week {
        .icon {
          background: #2084ff;
        }
        .num {
          color: #2084ff;
        }
      }
      &.month {
        .icon {
          background: #f7b500;
        }
        .num {
          color: #f7b500;
        }
      }
    }
  }
  .line {
    margin: 22px 24px 0;
    width: 398px;
    height: 31px;
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    align-items: center;
    div {
      height: 31px;
      &.day {
        background: #ff6c40;
      }
      &.week {
        background: #2084ff;
      }
      &.month {
        background: #f7b500;
      }
    }
  }
}
</style>
